<template>
  <div v-loading="loading" class="ec-line036 min-h-screen">
    <the-section v-if="isSpDevice" class="h-full">
      <div class="ec-line036__banner" v-safe-html="contentBanner"></div>
      <el-form ref="form" v-model="form" class="form">
        <p class="text-base mb-6">{{ $t('ec-line036.description') }}</p>
        <el-form-item prop="content">
          <el-input
            type="textarea"
            v-model="form.content"
            class="ec-line036__content-inquiry"
            :rows="6"
            :placeholder="$t('ec-line036.form.placeholder')"
            :maxlength="5000"
            :disabled="!friendFlag"
            resize="none"
          ></el-input>
        </el-form-item>

        <div class="ec-line036__checkbox flex justify-center w-full items-center">
          <el-checkbox v-model="isAcceptTermsOfUse"> </el-checkbox>
          <span class="ml-2 text-gray-950">
            <a class="font-bold underline" :href="Constants.SHOP_CONFIG.TERMS_OF_USE_URL">{{
              $t('ec-line020.checkbox.termsOfUse')
            }}</a
            ><span>{{ $t('ec-line020.checkbox.and') }}</span>
            <a class="font-bold underline" :href="Constants.SHOP_CONFIG.PRIVACY_POLICY_URL">{{
              $t('ec-line020.checkbox.privacyPolicy')
            }}</a
            ><span>{{ $t('ec-line020.checkbox.agree') }}</span>
          </span>
        </div>

        <div class="flex justify-center">
          <inquiry-shop-infor />
        </div>

        <div class="w-full flex justify-center">
          <el-button class="submit-btn rounded-3xl my-5 w-60" :disabled="!activeButton" @click="onSubmit">
            <span class="text-base font-bold">{{ $t('ec-line036.form.sendBtn') }}</span>
          </el-button>
        </div>
      </el-form>
    </the-section>
    <template v-else>
      <h2 class="text-center lg:pt-4 lg:pb-8 font-black">{{ $t('common.menu.lineContact') }}</h2>
      <div class="w-full bg-white pt-8 mb-4">
        <div class="flex flex-col items-center">
          <img :src="this.Constants.SHOP_CONFIG.LINE_ICON2" />
          <span class="font-black text-3xl leading-10 text-green">{{ $t('ec-line036.lineInquiryFlow.title') }}</span>
          <span class="text-base mt-2">{{ $t('ec-line036.lineInquiryFlow.description') }}</span>
        </div>
        <div class="mx-10 px-36 mt-6 pb-8 flex justify-between items-center">
          <div class="ec-line036__qr-frame">
            <span class="ec-line036__qr-description">{{ $t('ec-line036.lineInquiryFlow.qrDescription') }}</span>
            <img class="ec-line036__qr-code" width="315" id="qr-code" alt="" />
          </div>

          <div class="ec-line036__card-wrap">
            <div class="ec-line036__step-card">
              <span class="text-sm px-5 rounded bg-white text-green font-black">{{
                $t('ec-line036.lineInquiryFlow.step1.title')
              }}</span>
              <span class="font-black text-lg text-white mt-2">{{
                $t('ec-line036.lineInquiryFlow.step1.content')
              }}</span>
            </div>
            <div class="ec-line036__step-card">
              <span class="text-sm px-5 rounded bg-white text-green font-black">{{
                $t('ec-line036.lineInquiryFlow.step2.title')
              }}</span>
              <span class="font-black text-lg text-white mt-2">{{
                $t('ec-line036.lineInquiryFlow.step2.content')
              }}</span>
            </div>

            <div class="ec-line036__step-card">
              <span class="text-sm px-5 rounded bg-white text-green font-black">{{
                $t('ec-line036.lineInquiryFlow.step3.title')
              }}</span>
              <span class="font-black text-lg text-white mt-2">{{
                $t('ec-line036.lineInquiryFlow.step3.content')
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import TheSection from '@/components/TheSection.vue'
import { ENV_KEY } from '@/constants/env'
import liff from '@line/liff'
import QRCode from 'qrcode'
import { HtmlService, InquiryService } from '@/services'
import { getDevice, DEVICE } from '@/utils/helper.js'
import InquiryShopInfor from '@/components/ec-line020-021-022/InquiryShopInfor.vue'

const INQUIRY_TYPE = {
  UPDATE_MAIL: 'update-mail',
}
export default {
  components: {
    TheSection,
    InquiryShopInfor,
  },
  data() {
    return {
      title: this.$t('ec-line036.title'),
      friendFlag: false,
      form: {
        content: '',
      },
      loading: false,
      contentBanner: '',
      isAcceptTermsOfUse: false,
    }
  },

  computed: {
    activeButton() {
      return !!this.form.content.trim() && this.friendFlag && this.isAcceptTermsOfUse
    },
    isSpDevice() {
      return getDevice() === DEVICE.SP
    },
    isFromQrOfLine() {
      return /^true$/i.test(this.$route.query?.fromLineApp)
    },
  },
  created() {
    this.fetchBannerInquiry()
  },
  mounted() {
    Promise.all([this.createQrCode(), this.checkQueryType()])
  },
  methods: {
    async createQrCode() {
      if (liff.isLoggedIn() && this.isSpDevice) {
        const { friendFlag } = await liff.getFriendship()
        !friendFlag &&
          this.handleError({
            message: this.$t('ec-line036.lineAccountNotFriend'),
          })
        this.friendFlag = friendFlag
      }
      const url = await QRCode.toDataURL(
        `https://liff.line.me/${this.$store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID)}${
          this.$routePage.EC_LINE036
        }?fromLineApp=true`
      )
      var img = document.getElementById('qr-code')
      if (!img) return
      img.src = url
    },
    checkQueryType() {
      if (this.$route.query['type'] && this.$route.query['type'] === INQUIRY_TYPE.UPDATE_MAIL) {
        this.form.content = this.$t('ec-line036.lineInquiryFlow.updateMailContent')
      }
    },
    async fetchBannerInquiry() {
      const res = await HtmlService.getHtmlContent(this.Constants.SHOP_CONFIG.BANNER_INQUIRY_LINE)
      this.contentBanner = res.data
    },
    async onSubmit() {
      this.loading = true
      const message = [
        {
          type: 'text',
          text: `${this.$t('ec-line036.templateMessage.header')}\n${this.$t('ec-line036.templateMessage.content')}${
            this.form.content
          }`,
        },
      ]

      try {
        if (liff.isInClient() && !this.isFromQrOfLine) {
          //In case scan Qr code in app Line, not send message
          await liff.sendMessages(message)
          window.location.href = `https://line.me/R/ti/p/${this.$store.getters['env/GET_KEY'](ENV_KEY.LINE_BOT_ID)}`
          this.form.contents = ''
          return
        }

        await this.createInquiryLine()
        this.form.contents = ''

        this.$router.push(this.$routePage.EC_LINE037)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },

    async createInquiryLine() {
      const profile = await liff.getProfile()

      const payload = {
        line_id: profile.userId,
        text: `${this.$t('ec-line036.templateMessage.header')}\n${this.$t('ec-line036.templateMessage.content')}${
          this.form.content
        }`,
      }

      return InquiryService.createInquiryLine(payload)
    },
  },

  metaInfo() {
    return {
      title: this.title,
    }
  },
}
</script>
<style lang="scss">
@import '@/assets/css/pages/ec-line036.scss';
</style>
